// 系统管理路由
import type { RouteRecordRaw } from 'vue-router'
import { withAccessKeyMeta } from '@/router/access-map'
import { defaultLayout } from '@/router/base'

const routes: RouteRecordRaw[] = [
  {
    path: '/system',
    name: 'System',
    component: defaultLayout,
    meta: withAccessKeyMeta('system', {
      locale: 'common.menus.system',
      requiresAuth: true,
      icon: 'system',
      hideChildrenInMenu: true,
      activeMenu: 'System',
      order: 6,
    }),
    children: [
      {
        path: '',
        name: 'SystemIndex',
        component: () => import('@/views/system/index.vue'),
        meta: {
          locale: 'common.menus.system',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'System',
          isTopMenu: true,
        },
      },
    ],
  },
]

export default routes
